var _style, _path, _path2, _path3, _text, _text2, _text3, _path4, _text4, _path5, _text5, _path6, _text6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem14Ch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st4{font-family:&apos;ArialMT&apos;}.st5{font-size:16.5997px}.st6{fill:#369;fill-opacity:.502}.st7{fill:#fff}.st8{font-size:11.4815px}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 33.1012,
    cy: 381.5395,
    r: 26.2394,
    gradientTransform: "matrix(1.3158 0 0 1.3157 595.3704 -400.6415)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M662.3 124.6c12.7-15.5 12.7-31 0-46.4-6.8-6.5-14.6-9.7-23.4-9.7-8.7 0-16.5 3.2-23.2 9.7-12.9 15.4-12.9 30.9 0 46.4 6.7 6.4 14.4 9.6 23.2 9.6 8.9 0 16.6-3.2 23.4-9.6z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M705.9 95.9l-1.7-2.4-205.4 147.6 1.7 2.4L705.9 95.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 33.1185,
    cy: 381.5249,
    r: 18.0382,
    gradientTransform: "matrix(1.3158 0 0 1.3157 377.9351 -400.6415)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M437.8 117.6c9-10.9 9-21.7 0-32.5-4.8-4.5-10.2-6.7-16.3-6.7-6.2 0-11.5 2.2-16.2 6.7-9.1 10.8-9.1 21.6 0 32.5 4.6 4.5 10 6.8 16.2 6.8 6 0 11.5-2.3 16.3-6.8z",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M471.8 95.9l-1.8-2.4-205.4 147.6 1.7 2.4L471.8 95.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 33.1014,
    cy: 381.5395,
    r: 13.1656,
    gradientTransform: "matrix(1.3158 0 0 1.3157 154.9077 -400.6415)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.1 89.8c-3.4-3.2-7.3-4.9-11.7-4.9-4.3 0-8.1 1.6-11.5 4.9-6.5 7.7-6.5 15.4 0 23.2 3.3 3.2 7.2 4.8 11.5 4.8 4.4 0 8.4-1.6 11.7-4.8 6.4-7.8 6.4-15.5 0-23.2z",
    style: {
      fill: "url(#SVGID_3_)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.3 95.9l-1.7-2.4L30.1 241.1l1.8 2.4L237.3 95.9z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st4 st5",
    transform: "matrix(1.0002 0 0 1 679.5723 62.6187)"
  }, "\n    10\u516C\u65A4\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st5",
    transform: "matrix(1.0002 0 0 1 464.7842 62.6187)"
  }, "\n    5\u516C\u65A4\n  ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st5",
    transform: "matrix(1.0002 0 0 1 223.3843 62.6187)"
  }, "\n    1\u516C\u65A4\n  ")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.6 188.7c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st6"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st7 st4 st8",
    transform: "matrix(.9981 0 0 1 154.1172 202.2681)"
  }, "\n    1\n  ")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M429.8 188.7c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st6"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st7 st4 st8",
    transform: "matrix(.9981 0 0 1 417.2676 202.2681)"
  }, "\n    2\n  ")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M653.4 188.7c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st6"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "st7 st4 st8",
    transform: "matrix(.9981 0 0 1 640.917 202.2681)"
  }, "\n    3\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem14Ch);
export default __webpack_public_path__ + "static/media/item14ch.67d173acf8438f38ff2f827bef7631b8.svg";
export { ForwardRef as ReactComponent };